/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { MainPageEvent, useMainPageDataSelector } from ".";
import HmsInput from "../Common/element/HmsInput";
import Modal from "react-bootstrap/Modal";

function EditProfileModal() {
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");

  const [updating, setUpdating] = useState<boolean>(false);
  const mainPageData = useMainPageDataSelector();

  const validationProps = {
    minLength: 1,
    maxLength: 20,
    lengthErrorMsg: "This field cannot be empty",
  };

  const updatingAction = () => {
    setUpdating(true);
    const appUser = {
      id: mainPageData.appUser.id,
      firstName,
      lastName,
      msisdn: mainPageData.appUser.msisdn,
    };
    dispatch({
      type: MainPageEvent.UPDATE_USER,
      appUser,
      token: mainPageData.authToken,
    });
  };

  const hideEditProfileModalAction = () => {
    dispatch({
      type: MainPageEvent.HIDE_EDIT_PROFILE_MODAL,
    });
  };

  return (
    <Modal
      show={mainPageData.showEditProfileModal}
      onHide={() => hideEditProfileModalAction()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Profile</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <label>First Name</label>
        <HmsInput
          inputType="text"
          className="form-control bg-back border-0 mt-1 mb-2"
          placeHolder="First Name"
          value={firstName}
          validProps={validationProps}
          handleChange={setFirstName}
        />
        <label>Last Name</label>
        <HmsInput
          inputType="text"
          className="form-control bg-back border-0 mt-1"
          placeHolder="Last Name"
          value={lastName}
          validProps={validationProps}
          handleChange={setLastName}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => hideEditProfileModalAction()}
        >
          Close
        </button>
        <button
          disabled={updating}
          className="btn btn-primary"
          data-toggle="modal"
          data-target="#write-review-modal"
          onClick={() => updatingAction()}
        >
          <i className={updating ? "fas fa-spin fa-circle-notch" : ""}></i>
          {updating ? "Updating..." : "Update"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditProfileModal;
